"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "presentationControlNotifier", {
  enumerable: true,
  get: function get() {
    return _presentationControlNotifier["default"];
  }
});
var _presentationControlNotifier = _interopRequireDefault(require("./presentationControlNotifier"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }